module.exports = __webpack_public_path__ + "img/lnk-profile.439611fb.svg";